// Shared current-user/role helpers (single source for role checks).
export function getUser() {
  try { return JSON.parse(localStorage.getItem('user')) || null; }
  catch (_) { return null; }
}
export function getRole() {
  return getUser()?.role || null;
}
export function isLimitedAdmin() {
  return getRole() === 'LIMITED_ADMIN';
}
